import React, { useEffect, useState } from 'react'
import {
  UsergroupAddOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  ManOutlined,
  WomanOutlined,
  DollarOutlined,
  FundOutlined,
} from '@ant-design/icons'

import { Select, Card } from 'antd'
import './AdminCss.css'
import Footer from '../CommonComponent/Footer'
import AdminHeader from '../CommonComponent/AdminHeader'
import axios from 'axios'
import { AdminDashboard } from '../../AllAPI/AdminAPI'
import { useNavigate } from 'react-router-dom'

const { Option } = Select

const Dashboard = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  const navigate = useNavigate()

useEffect(() => {
  const userData = sessionStorage.getItem('userData')

  if (!userData) {
    sessionStorage.clear()
    navigate('/', { replace: true })
  }
}, [navigate])


  // ------------------- Disable Back Button -------------------
  useEffect(() => {
    // Push a dummy state
    window.history.pushState(null, null, window.location.href)

    const handlePopState = () => {
      // Push forward again
      window.history.pushState(null, null, window.location.href)
    }

    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [])
  // ===================================================================

  const [stats, setStats] = useState(null)

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get(AdminDashboard)
        setStats(response.data)
      } catch (error) {
        console.log('Error fetching dashboard stats:', error)
      }
    }

    fetchStats()
  }, [])

  // const cardItems = [
  //   {
  //     title: 'Reg. Pending Members',
  //     key: 'registration_pending_count',
  //     icon: <UsergroupAddOutlined className="icon" />,
  //     color: 'icon-blue',
  //   },
  //   {
  //     title: 'Pending Approvals',
  //     key: 'pendingApprovalCount',
  //     icon: <ClockCircleOutlined className="icon" />,
  //     color: 'icon-yellow',
  //   },
  //   {
  //     title: 'Approved Registrations',
  //     key: 'approvalRegistrationCount',
  //     icon: <CheckCircleOutlined className="icon" />,
  //     color: 'icon-green',
  //   },
  //   {
  //     title: 'Male Count',
  //     key: 'totalMaleCount',
  //     icon: <ManOutlined className="icon" />,
  //     color: 'icon-indigo',
  //   },
  //   {
  //     title: 'Female Count',
  //     key: 'totalFemaleCount',
  //     icon: <WomanOutlined className="icon" />,
  //     color: 'icon-pink',
  //   },
  //   {
  //     title: 'Total Approval Amount',
  //     key: 'totalApprovalAmount',
  //     icon: <DollarOutlined className="icon" />,
  //     color: 'icon-purple',
  //   },
  //   {
  //     title: "Today's Approval Amount",
  //     key: 'todayApprovalAmount',
  //     icon: <FundOutlined className="icon" />,
  //     color: 'icon-orange',
  //   },
  // ]

    const cardItems = [
    {
      title: 'Reg. Pending Members',
      key: 'registration_pending_count',
      icon: <UsergroupAddOutlined className="icon" />,
      color: 'icon-blue',
    },
    {
      title: 'Pending Approvals',
      key: 'pendingApprovalCount',
      icon: <ClockCircleOutlined className="icon" />,
      color: 'icon-yellow',
    },
    {
      title: 'Approved Registrations (800₹)',
      key: 'approvalRegistrationCount',
      icon: <CheckCircleOutlined className="icon" />,
      color: 'icon-green',
    },
    {
      title: 'Approved Registrations (300₹)',
      key: 'approvalRegistrationThreeHundredRsCount',
      icon: <CheckCircleOutlined className="icon" />,
      color: 'icon-green',
    },
    {
      title: 'Approved Registrations (200₹)',
      key: 'approvalRegistrationTwoHundredRsCount',
      icon: <CheckCircleOutlined className="icon" />,
      color: 'icon-green',
    },
    {
      title: 'Male Count',
      key: 'totalMaleCount',
      icon: <ManOutlined className="icon" />,
      color: 'icon-indigo',
    },
    {
      title: 'Female Count',
      key: 'totalFemaleCount',
      icon: <WomanOutlined className="icon" />,
      color: 'icon-pink',
    },
    {
      title: 'Total Approval Amount (800₹)',
      key: 'totalApprovalAmount',
      icon: <DollarOutlined className="icon" />,
      color: 'icon-purple',
    },
    {
      title: 'Total Approval Amount (300₹)',
      key: 'totalApprovalThreeHundredRsAmount',
      icon: <DollarOutlined className="icon" />,
      color: 'icon-purple',
    },
    {
      title: 'Total Approval Amount (200₹)',
      key: 'totalApprovalTwoHundredRsAmount',
      icon: <DollarOutlined className="icon" />,
      color: 'icon-purple',
    },
    {
      title: "Today's Approval Amount",
      key: 'todayApprovalAmount',
      icon: <FundOutlined className="icon" />,
      color: 'icon-orange',
    },
  ]

  return (
    <div className="bg-gray-100 min-h-screen">
      <AdminHeader />

      <div className="row m-0 p-md-5 pt-0">
        <div className="col-12 col-md-2"></div>

        <div className="col-12 col-md-8 pb-5">
          <header className="reg-header pt-2 pt-md-0">
            <h3 className="reg-title"> Dashboard </h3>
          </header>

          <div className="dashboard-grid pb-5 pt-3">
            {cardItems.map((item, index) => (
              <Card key={index} className="dashboard-card">
                <div className="card-content">
                  <div className={`icon-box ${item.color}`}>{item.icon}</div>

                  <div>
                    <p className="card-title">{item.title}</p>
                    <h2 className="card-count">
                      {stats ? stats[item.key] ?? 0 : '--'}
                    </h2>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>

        <div className="col-12 col-md-2"></div>
      </div>

      <Footer />
    </div>
  )
}

export default Dashboard
